import { render, staticRenderFns } from "./voiceIntercom.vue?vue&type=template&id=3545287e&scoped=true&"
import script from "./voiceIntercom.vue?vue&type=script&lang=js&"
export * from "./voiceIntercom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3545287e",
  null
  
)

export default component.exports